import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { ROUTES } from '../../utils/constants';
import ProfileDropdown from './ProfileDropdown';
import './Header.css';

export default function Header() {
  const { isAuthenticated, userProfile } = useAuthContext();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Top Header */}
      <header className="header">
        <div className="header-container">
          <Link to={ROUTES.HOME} className="header-logo">
            <span className="logo-icon">🔥</span>
            <span className="logo-text">Streak for Cash</span>
          </Link>

          <nav className="header-nav">
            <Link
              to={ROUTES.HOME}
              className={`nav-link ${isActive(ROUTES.HOME) ? 'active' : ''}`}
            >
              Home
            </Link>
            <Link
              to={ROUTES.GAMES}
              className={`nav-link ${isActive(ROUTES.GAMES) ? 'active' : ''}`}
            >
              Games
            </Link>
            {isAuthenticated && (
              <Link
                to={ROUTES.MY_PICKS}
                className={`nav-link ${isActive(ROUTES.MY_PICKS) ? 'active' : ''}`}
              >
                My Picks
              </Link>
            )}
            <Link
              to={ROUTES.ARENA}
              className={`nav-link ${isActive(ROUTES.ARENA) ? 'active' : ''}`}
            >
              Arena
            </Link>
          </nav>

          <div className="header-right">
            {isAuthenticated && userProfile ? (
              <ProfileDropdown />
            ) : isAuthenticated ? (
              <Link to={ROUTES.REGISTER} className="btn btn-sm">
                Complete Setup
              </Link>
            ) : (
              <Link to={ROUTES.LOGIN} className="btn btn-sm">
                Sign In
              </Link>
            )}
          </div>
        </div>
      </header>

      {/* Mobile Bottom Tab Bar */}
      <nav className="mobile-tab-bar">
        <Link
          to={ROUTES.HOME}
          className={`tab-item ${isActive(ROUTES.HOME) ? 'active' : ''}`}
        >
          <span className="tab-icon">🏠</span>
          <span className="tab-label">Home</span>
        </Link>
        <Link
          to={ROUTES.GAMES}
          className={`tab-item ${isActive(ROUTES.GAMES) ? 'active' : ''}`}
        >
          <span className="tab-icon">🎮</span>
          <span className="tab-label">Games</span>
        </Link>
        {isAuthenticated && (
          <Link
            to={ROUTES.MY_PICKS}
            className={`tab-item ${isActive(ROUTES.MY_PICKS) ? 'active' : ''}`}
          >
            <span className="tab-icon">✅</span>
            <span className="tab-label">Picks</span>
          </Link>
        )}
        <Link
          to={ROUTES.ARENA}
          className={`tab-item ${isActive(ROUTES.ARENA) ? 'active' : ''}`}
        >
          <span className="tab-icon">⚔️</span>
          <span className="tab-label">Arena</span>
        </Link>
        <Link
          to={ROUTES.PROFILE_SETTINGS}
          className={`tab-item ${location.pathname.startsWith('/profile') ? 'active' : ''}`}
        >
          <span className="tab-icon">👤</span>
          <span className="tab-label">Profile</span>
        </Link>
      </nav>
    </>
  );
}
